//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState } from 'react';
// import './style.scss';
import { useStore } from '../../store/store';
import { format } from 'date-fns';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import WeightChart from 'src/onboarding/components/ui/graph/Graph';
import { getMonthName } from 'src/onboarding/helpers/getMonthName';
import { getFullMonthName } from 'src/onboarding/helpers/getFullMonthName';

function Page() {
  const idealWeight = useStore((state) => state.idealWeight);
  const when = useStore((state) => state.when);
  const weight = useStore((state) => state.weight);
  const loosGoal = useStore((state) => state.loosGoal);

  const { onNext, onPrev, currentIndex } = useNav();
  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>
          <span style={{ color: '#00CE00' }}>
            {idealWeight.value} {idealWeight.type}
          </span>{' '}
          {t('onboarding.goal.byTitle')}{' '}
          {t(`onboarding.common.calendar.${getFullMonthName(when.month)}`)}{' '}
          {format(new Date(when.year + '-' + when.month + '-' + when.day + 'T00:00:00'), 'yyyy')}
        </Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {loosGoal === 'Maintain weight and get fit'
            ? t('onboarding.goal.subTitleWithoutWeightLoss')
            : t('onboarding.goal.subTitle')}
        </Text>
      </div>

      <WeightChart
        weightNow={weight.type === 'kg' ? weight.kg : weight.lbs}
        dateWhen={when}
        weightWhen={idealWeight.value}
        unit={weight.type === 'kg' ? 'kg' : 'lbs'}
      />

      <div className={'next-wrapper'}>
        <Button title={t('onboarding.goal.continue')} onClick={onNext} />
      </div>
    </div>
  );
}

export default Page;
